import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";
import { useAuth } from "../auth/AuthProvider";
import { BrandLogo } from "../components/Brand";

/** Landing point of the PKCE redirect: exchanges the code, then continues to the page the user asked for. */
export default function AuthCallback() {
  const { t } = useTranslation();
  const { completeSignIn } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // React StrictMode mounts twice; the code can be exchanged once only
    ran.current = true;
    completeSignIn()
      .then((to) => navigate(to, { replace: true }))
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)));
  }, [completeSignIn, navigate]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#F6F8FA] p-6 text-brand-charcoal">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow">
        <BrandLogo variant="mark" className="mx-auto h-12" />
        {error ? (
          <>
            <h1 className="mt-4 font-heading text-lg font-semibold text-status-red">{t("auth.callbackError")}</h1>
            <p className="mt-2 break-words text-xs text-brand-grey">{error}</p>
            <Link to="/" className="mt-6 inline-block rounded bg-brand-primary px-4 py-2 text-sm font-semibold text-white">{t("common.retry")}</Link>
          </>
        ) : (
          <p className="mt-4 text-sm text-brand-grey">{t("auth.signingIn")}</p>
        )}
      </div>
    </main>
  );
}
